import React, { useMemo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import InfoLayout from "components/InfoLayout";
import UsageOverview from "views/usage-overview";
import TokenUsageHistory from "views/usage-overview/history";
import { useTranslation } from "react-i18next";

const getUsageHeaderKey = (location: Location): string => {
  const path = location.pathname.replace("/dashboard/usage-overview", "");
  return path === "" ? "/" : `/${path}`;
};

// Empty sidebar component since we don't need navigation
const EmptySidebar = (): null => null;

const UsageOverviewLayout: React.FC = () => {
  const { t } = useTranslation();

  const headerMap = useMemo(
    () => ({
      "/": {
        title: t("usageOverview.overviewHeader.title"),
        subtitle: t("usageOverview.overviewHeader.subtitle"),
      },
      "/history/:apiKeyId": {
        title: t("usageOverview.historyHeader.title"),
        subtitle: t("usageOverview.historyHeader.subtitle"),
      },
    }),
    [t]
  );

  return (
    <InfoLayout
      Sidebar={EmptySidebar}
      headerMap={headerMap}
      getHeaderKey={getUsageHeaderKey}
    >
      <Routes>
        <Route path="/" element={<UsageOverview />} />
        <Route path="/history/:apiKeyId" element={<TokenUsageHistory />} />
        <Route path="*" element={<Navigate to="/dashboard/usage-overview" />} />
      </Routes>
    </InfoLayout>
  );
};

export default UsageOverviewLayout;
